module.exports = __webpack_public_path__ + "img/zhangqiangfeng.f9da7f2e.png";